import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";

import { applyBranding, type Branding, FALLBACK, fetchBranding } from "./branding";

/** The brand, fetched once and shared by every screen; applied to the tab title and theme colour. */
export function useBranding(): { brand: Branding; loading: boolean } {
  const { data, isLoading } = useQuery({
    queryKey: ["branding"],
    queryFn: ({ signal }) => fetchBranding(signal),
    staleTime: Infinity,
  });
  useEffect(() => {
    if (data) applyBranding(data);
  }, [data]);
  return { brand: data ?? FALLBACK, loading: isLoading };
}
